// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1A-dM","footer":"ReportModalFilter_footer__2aEui"};